import { Stack, Typography } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import type { Details } from "utils/listings/display";

export function NestedRowDetails({ title, value, usingRTL, Icon }: Details): JSX.Element {
  return (
    <Stack sx={{ color: grey[600] }}>
      <Typography variant="subtitle1">{title}</Typography>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography
          style={{ direction: usingRTL ? "rtl" : "ltr" }}
          variant="subtitle1"
          color="primary.main"
        >
          {value}
        </Typography>
        {Icon && <Icon />}
      </Stack>
    </Stack>
  );
}
